import { Injectable, inject } from '@angular/core';
import { EntityQueue, EntityQueueCqrsActions, EntityQueueListItem, EntityQueueListResponse } from '@jms/model';
import { InboxRoomService } from '../../shared/services/inbox.room.service';

@Injectable({ providedIn: 'root' })
export class InboxQueueSocketService {

    private readonly inboxRoom = inject(InboxRoomService);

    public getAll(): Promise<EntityQueueListResponse> {

        return this.inboxRoom.dispatch<EntityQueueListResponse>(EntityQueueCqrsActions.List, {});
    }

    public getById(queueId: string): Promise<EntityQueue | null> {

        return this.inboxRoom.dispatch<EntityQueue | null>(EntityQueueCqrsActions.Get, { request: { queueId } });
    }

    public save(queue: Partial<EntityQueue>): Promise<EntityQueueListItem> {

        return this.inboxRoom.dispatch<EntityQueueListItem>(EntityQueueCqrsActions.Create, { request: { queue } });
    }

    public patch(queueId: string, queue: Partial<EntityQueue>): Promise<EntityQueueListItem> {

        return this.inboxRoom.dispatch<EntityQueueListItem>(EntityQueueCqrsActions.Update, { request: { queueId, queue } });
    }

    public delete(queueId: string): Promise<void> {

        return this.inboxRoom.dispatch<void>(EntityQueueCqrsActions.Delete, { request: { queueId } });
    }
}
